var jqueryRequest = require('./jqueryRequest');
module.exports = require('../lib/clientBuilder')(jqueryRequest);



/*****************
 ** WEBPACK FOOTER
 ** ./~/@okta/okta-auth-js/jquery/index.js
 ** module id = 415
 ** module chunks = 0
 **/